import apiService from '../apiService';

const BASE = '/api/admin/inventory-items';

export const getInventoryItems = (params = {}) => apiService.GET(BASE, params);

export const getInventoryItem = (id) => apiService.GET(`${BASE}/${id}`);

export const createInventoryItem = (formData) =>
    apiService.POST(BASE, formData);

/**
 * 更新物品藍圖
 * 含封面圖 FormData 時必須走 POST + _method=PUT
 * （PHP/Laravel 對原生 PUT multipart 不會解析檔案，hasFile 永遠 false）
 */
export const updateInventoryItem = (id, formData) => {
    const url = `${BASE}/${id}`;
    if (formData instanceof FormData) {
        if (!formData.has('_method')) {
            formData.append('_method', 'PUT');
        }
        return apiService.POST(url, formData);
    }
    return apiService.PUT(url, formData);
};

export const deleteInventoryItem = (id) => apiService.DELETE(`${BASE}/${id}`);
